module.exports = __webpack_public_path__ + "static/media/mpayicon2.55928c20.png";